/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_DescriptionInputs */

const en_admin_invite_codes_description = /** @type {(inputs: Admin_Invite_Codes_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage invite codes for sign-up`)
};

/**
* | output |
* | --- |
* | "Manage invite codes for sign-up" |
*
* @param {Admin_Invite_Codes_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_description = /** @type {((inputs?: Admin_Invite_Codes_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_invite_codes_description(inputs)
});
export { admin_invite_codes_description as "admin.invite_codes.description" }